import { useCallback } from 'react';
import { getUsageTracker, UsageTracker } from '../utils/usageTracker';

const USAGE_EVENT_KEY = 'contentGenerationModalInteraction';

export type TrackUsageChoice =
  | 'friendly'
  | 'professional'
  | 'witty'
  | 'heartfelt'
  | 'educational';

export type TrackUsageExtraProps = {
  selected?: string;
  choice?: TrackUsageChoice;
  command?: string;
  text?: string;
  result?: string;
  usageDescription?: string;
  inline?: string;
  inApp?: string;
  regenerateClickCount?: number;
  usingBrandVoice?: boolean;
};

export type TrackUsage = (
  action: string,
  extraProps?: TrackUsageExtraProps | {},
  eventKey?: string
) => void;

export type TrackInteraction = (
  action: string,
  props?: {},
  eventKey?: string
) => void;

type UseUsageTrackerProps = {
  usageTracker?: UsageTracker;
  usageDescription: string;
  eventKey?: string;
  trackInteraction?: TrackInteraction;
};

export const useUsageTracker = ({
  usageTracker,
  usageDescription,
  eventKey,
  trackInteraction,
}: UseUsageTrackerProps) => {
  const trackUsage: TrackUsage = useCallback(
    (action, extraProps = {}) => {
      if (usageTracker) {
        const _usageTracker = getUsageTracker(usageTracker, usageDescription);
        const properties = {
          action,
          ...extraProps,
        };
        _usageTracker.track(eventKey || USAGE_EVENT_KEY, properties);
      } else if (trackInteraction) {
        trackInteraction(action, { usageDescription, ...extraProps }, eventKey);
      }
    },
    [eventKey, trackInteraction, usageDescription, usageTracker]
  );

  return trackUsage;
};
